module.exports = __webpack_public_path__ + "static/dominik-1b5b07a75747758fad57c90f77c55c36.png";